"use client";

import { AgeType } from "libs/cat-calculations/src/lib/cat-calculations.types";
import { RecipesForCatResponse } from "@forms/schema";
import {
  PricingPlan,
  TPricingPlan,
  type TAllergen,
  type TRecipeItem,
} from "@./suf-store";
import {
  getFreshTrialRecipes,
  RecipeCount,
  SHREDDED_RELAUNCH,
} from "libs/recipes/src/lib/recipes";
import { FRESH_PRICING_PLAN_DETAILS } from "@./types/subscriptions/constants";
import { useFlagVariant } from "libs/hooks/src";

/**
 * Returns trial recipes based on the user's plan (7 or 14 recipes).
 * Reads planType from store to determine recipe count.
 */
export const useFreshTrialRecipes = (
  { planType, formName }: { planType: TPricingPlan | undefined; formName?: string },
) => {
  const trialPlan = planType ?? PricingPlan.TRIAL;
  const isTestVariant = trialPlan === PricingPlan.TRIAL_WEEK;
  const recipeCount = FRESH_PRICING_PLAN_DETAILS[trialPlan].quantity as RecipeCount;
  const isShreddedEnabled = useFlagVariant(SHREDDED_RELAUNCH, { formName });

  const getRecipes = (
    allergies: TAllergen[],
    lifeStage: AgeType,
    recipeItems?: TRecipeItem[],
  ): RecipesForCatResponse => getFreshTrialRecipes(
    allergies,
    lifeStage,
    recipeItems,
    recipeCount,
    isShreddedEnabled,
  );

  return {
    getRecipes,
    recipeCount,
    isTestVariant,
    isShreddedEnabled,
  };
};
